module.exports = __webpack_public_path__ + "f9b4d6f8239c5bdfe31e02ffc8dd8ae7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/lightning-logo-white.svg
// module id = 1688
// module chunks = 5